import React, { memo, useMemo } from "react";
import { CartGroupTitle } from "@cart-ui/components/cart-group";
import { getCloudinaryUrl, useEffectOnce } from "@swiggy-private/core-ui";
import cx from "classnames";
import { ICONS } from "@cart-ui/constants";
import {
    Widget,
    WidgetTopTitle,
    WidgetHeader,
    WidgetHeaderText,
    WidgetHeaderTextRow,
    WidgetHeaderTextRowContent,
    WidgetHeaderTextRowGiftIcon,
    WidgetHeaderTextSubTitle,
    WidgetHeaderActionBtn,
} from "./styles";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export interface EditNumberWidgetProps {
    title?: string;
    subTitle?: string | null;
    actionText?: string;
    showGiftIcon?: boolean;
    onActionClick: VoidFunction;
    className?: string;
    onImpression?: VoidFunction;
    showTitleAboveWidget?: boolean;
}

const IMAGE_SIZE = 48;
export const TESTID_WIDGET_GROUP_TITLE = "EDIT_NUMBER_WIDGET_GROUP_TITLE";

const EditNumberWidget = ({
    title = "",
    subTitle,
    actionText = "",
    showGiftIcon,
    onActionClick,
    className,
    onImpression,
    showTitleAboveWidget = false,
}: EditNumberWidgetProps): React.ReactElement => {
    useEffectOnce(() => {
        onImpression?.();
    });

    const wrapperClass = useMemo(() => cx(className), [className]);

    return (
        <>
            {showTitleAboveWidget && (
                <WidgetTopTitle>
                    <CartGroupTitle title={title} data-testid={TESTID_WIDGET_GROUP_TITLE} />
                </WidgetTopTitle>
            )}
            <Widget className={wrapperClass}>
                <WidgetHeader>
                    <WidgetHeaderText>
                        <WidgetHeaderTextRow>
                            {!showTitleAboveWidget && (
                                <>
                                    <WidgetHeaderTextRowContent>{title}</WidgetHeaderTextRowContent>
                                    {showGiftIcon && (
                                        <WidgetHeaderTextRowGiftIcon
                                            imageUrl={getCloudinaryUrl(ICONS.MYSTERY_BOX, {
                                                width: IMAGE_SIZE,
                                                height: IMAGE_SIZE,
                                            })}
                                        />
                                    )}
                                </>
                            )}
                        </WidgetHeaderTextRow>
                        {subTitle && <WidgetHeaderTextSubTitle>{subTitle}</WidgetHeaderTextSubTitle>}
                    </WidgetHeaderText>
                    <WidgetHeaderActionBtn onClick={onActionClick}>
                        <Text variant="V2.body2.neutral.bold" color="special_primary">
                            {actionText}
                        </Text>
                    </WidgetHeaderActionBtn>
                </WidgetHeader>
            </Widget>
        </>
    );
};

export default memo(EditNumberWidget);
